<mat-card appearance="outlined" class="container">
  <mat-card-header class="secondary-background-element main-card flex-center">


    <div class="bulk-actions">
      <button mat-button [matMenuTriggerFor]="bulkActions">
        <span class='mat-body flex-center'><span class='v-middle'>Bulk actions</span>
        <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
      </span>
    </button>
    <mat-menu #bulkActions="matMenu" xPosition="before">
      <button (click)="activateSelectedUsers()" mat-menu-item>Activate user</button>
      <button (click)="deactivateSelectedUsers()" mat-menu-item>Deactivate user</button>
      <button (click)="resendInvitationsForSelectedUsers()" mat-menu-item>Resend invitation</button>

    </mat-menu>
  </div>
  <div class="role-filter">
    <button mat-button [matMenuTriggerFor]="filterRole">
      <span class='mat-body flex-center'><span class='v-middle'>{{getShownRole()}}</span>
      <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
    </span>
  </button>
  <mat-menu #filterRole="matMenu" xPosition="before">
    <button (click)="setRoleFilter()" mat-menu-item>All roles</button>
    <button (click)="setRoleFilter(UserRolesEnum.hcp)" mat-menu-item>Only
    HCPs</button>
    <button (click)="setRoleFilter(UserRolesEnum.ent)" mat-menu-item>Only
    ENTs</button>
    <button (click)="setRoleFilter(UserRolesEnum.dal)" mat-menu-item>Only
    DALs</button>
  </mat-menu>
</div>
<div class="country-filter">
  <button mat-button [matMenuTriggerFor]="filterCountry">
    <span class='mat-body flex-center'><span class='v-middle'>{{getShownCountry()}}</span>
    <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
  </span>
</button>
<mat-menu #filterCountry="matMenu" xPosition="before">
  <button (click)="setCountryFilter()" mat-menu-item>All countries</button>
  @for (country of CountriesIDs | keyvalue; track country) {
    <button  (click)="setCountryFilter(country.value)" mat-menu-item>{{getFullCountryName(country.value)}}</button>
  }

</mat-menu>
</div>
<span class="spacer"></span>

<button mat-icon-button (click)="refreshTable()" class="flex-child-wrapper">
  <mat-icon svgIcon="refresh"></mat-icon>
</button>
</mat-card-header>

<mat-card-content>


  <!--  table columns definitions -->
  <table mat-table matSort color="accent" class='closer-sort' aria-label="Elements" [dataSource]="dataSource"
    [matSortActive]="this.dataSource.sortingHeader" [matSortDirection]="this.dataSource.sortDirection">

    <ng-container matColumnDef="bulk">
      <th mat-header-cell *matHeaderCellDef>
        <!-- checkmark for bulk -->
        <mat-checkbox class="accent-check " (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox class="accent-check " (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Name</h3>
      </th>
      <td mat-cell *matCellDef="let row" [matTooltip]="'User ID: '+row.userId">
        <h3 class="not-bold">{{row.firstName}} {{row.lastName}}</h3>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>E-mail</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.email) {
          <p [matTooltip]="row.email">{{row.email}}
          </p>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Role</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.role) {
          <div>
            <span>{{row.role}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Status</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.status) {
          <div>
            <span>{{row.status}}</span><br>
            <span>{{row.statusDate| date: 'yyyy-MM-dd'}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Country</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.country) {
          <div>
            <span>{{row.country}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="clinicId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Clinic ID/ Office ID</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.role==UserRolesEnum.hcp) {
          <div>
            @if (row.clinicId) {
              <div>
                <span [matTooltip]="row.shopList.join(', ')"
                  matTooltipPosition="above">{{row.clinicId}}@if (row.shopList.length>1) {
                  <span>,
                  ...</span>
                }</span>
              </div>
            } @else {
              <mat-icon svgIcon='dash'></mat-icon>
            }
          </div>
        }
        @if (row.role==UserRolesEnum.ent) {
          <div>
            @if (row.entOfficeId) {
              <div>
                <span>{{row.entOfficeId}}</span>
              </div>
            } @else {
              <mat-icon svgIcon='dash'></mat-icon>
            }
          </div>
        }
        @if (row.role==UserRolesEnum.dal) {
          <div>
            <ng-container *ngTemplateOutlet="none"></ng-container>
          </div>
        }

      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <h3>Actions</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="flex" >
          <div class="first-action">
            @switch (row.status) {
              @case (UserStatusesEnum.invited) {
                <div>
                  @if ((row.invitationProgress$|async) != SendindStatesEnum.sent) {
                    <button matTooltip="Resend invitation" mat-icon-button
                      [disabled]="(row.invitationProgress$|async) == SendindStatesEnum.sending"
                      (click)="resendInvitation(row.userId)">
                      <mat-icon class='secondary-contrast-icon'>mail</mat-icon>
                    </button>
                  } @else {
                    <button mat-icon-button disabled class="immitation-button">
                      <mat-icon svgIcon='checkmark' class="sent-button-icon secondary-contrast-icon"></mat-icon>
                    </button>
                  }
                </div>
              }
              @default {
                <mat-slide-toggle
                  [matTooltip]="(row.status==UserStatusesEnum.active)?'Deactivate user':'Activate user'"
                  (change)="changeUserStatus($event,row)"
                [checked]="row.status==UserStatusesEnum.active"></mat-slide-toggle>
              }
            }
          </div>

          <button matTooltip="Edit user" mat-icon-button (click)="editUser(row)">

            <mat-icon class='secondary-contrast-icon'>edit</mat-icon>
          </button>

          <button mat-icon-button (click)="deleteUser(row)">

            <mat-icon matTooltip="Delete user" class='secondary-contrast-icon'>delete</mat-icon>
          </button>

        </div>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>

  <!-- progress indicator that we are to indicate that data is being loaded from the backend  -->
  @if ((this.dataSource.loading$ | async); as loading) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
  }

  <mat-paginator color='accent' [length]="dataSource.count" [pageIndex]=" this.dataSource.pageIndex"
    [pageSize]="this.dataSource.pageSize" [pageSizeOptions]="[10,20,50]">
  </mat-paginator>
</mat-card-content>
</mat-card>

<ng-template #none>
  <mat-icon svgIcon='dash'></mat-icon>
</ng-template>
